/* Miss Bean - Cafe Animations JS */
(function() {
  'use strict';

  // --- Scroll Reveal ---
  function initScrollReveal() {
    const revealEls = document.querySelectorAll('.mb-reveal, .mb-reveal-left, .mb-reveal-right, .mb-reveal-scale, .mb-stagger');
    if (!revealEls.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mb-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    revealEls.forEach(function(el) { observer.observe(el); });
  }

  // --- Parallax ---
  function initParallax() {
    const parallaxEls = document.querySelectorAll('.mb-parallax');
    if (!parallaxEls.length) return;

    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function(el) {
        var speed = parseFloat(el.dataset.parallaxSpeed) || 0.3;
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + scrollY - window.innerHeight / 2) * speed;
        el.style.transform = 'translateY(' + (-offset * 0.1) + 'px)';
      });
    }, { passive: true });
  }

  // --- Floating Leaves ---
  function initParticles() {
    var container = document.querySelector('.mb-particles');
    if (!container) return;

    var leafSvg = '<svg viewBox="0 0 100 100"><ellipse cx="50" cy="50" rx="30" ry="45" fill="#4a2c17"/><path d="M50 8 C45 30 45 70 50 92" fill="none" stroke="#2a1a0a" stroke-width="3"/></svg>';

    for (var i = 0; i < 8; i++) {
      var particle = document.createElement('div');
      particle.className = 'mb-particle mb-particle--leaf';
      particle.innerHTML = leafSvg;
      // Place only in left (0-10%) or right (90-100%) margins
      var side = Math.random() > 0.5;
      particle.style.left = side ? (90 + Math.random() * 10) + '%' : (Math.random() * 10) + '%';
      particle.style.animationDuration = (8 + Math.random() * 12) + 's';
      particle.style.animationDelay = (Math.random() * 10) + 's';
      particle.style.width = (15 + Math.random() * 15) + 'px';
      particle.style.height = particle.style.width;
      container.appendChild(particle);
    }
  }

  // --- Auto-apply reveal classes to sections ---
  function autoApplyAnimations() {
    // Video collage items
    var videoGrid = document.querySelector('.video-collage__grid');
    if (videoGrid) videoGrid.classList.add('mb-stagger', 'mb-reveal');

    // New launches sliders
    document.querySelectorAll('.new-launches-slider').forEach(function(el) {
      el.classList.add('mb-reveal');
    });

    // Section headings
    document.querySelectorAll('.new-launches-section-title, .video-collage__heading, .new-launches-subtitle').forEach(function(el) {
      el.classList.add('mb-reveal');
    });

    // Menu items (cafe-menu)
    document.querySelectorAll('.mb-menu__item').forEach(function(el) {
      el.classList.add('mb-hover-glow');
    });

    // Category images
    document.querySelectorAll('.mb-menu__category-img').forEach(function(el) {
      el.classList.add('mb-parallax');
    });

    // Slider items hover
    document.querySelectorAll('.new-launches-slider__item').forEach(function(el) {
      el.classList.add('mb-hover-lift');
    });

    // Video collage items hover
    document.querySelectorAll('.video-collage__item').forEach(function(el) {
      el.classList.add('mb-hover-lift');
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', function() {
    autoApplyAnimations();
    initScrollReveal();
    initParallax();
    initParticles();
  });
})();
